import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Calendar, ChevronRight, LogOut } from "lucide-react";

const EventsPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const events = user?.events || [];

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-black text-white" data-testid="events-page">
      <header className="border-b border-gray-800 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold" style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.05em' }}>
              My Events
            </h1>
            <p className="text-gray-500 text-sm">{user?.name} &middot; {user?.email}</p>
          </div>
          <Button variant="ghost" onClick={handleLogout} className="text-gray-400 hover:text-white" data-testid="logout-btn">
            <LogOut size={18} className="mr-2" /> Logout
          </Button>
        </div>
      </header>

      <div className="max-w-4xl mx-auto p-6">
        <div className="space-y-3">
          {events.map(event => (
            <Card key={event.event_id} className="p-6 glass hover:border-purple-500/30 transition-all cursor-pointer group" onClick={() => navigate(`/event/${event.slug}/director`)} data-testid={`event-select-${event.slug}`}>
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-white group-hover:text-purple-400 transition-colors">{event.name}</h3>
                  {event.description && <p className="text-sm text-gray-500 mt-1">{event.description}</p>}
                  <p className="text-xs text-gray-600 mt-2">/event/{event.slug}</p>
                </div>
                <ChevronRight size={24} className="text-gray-600 group-hover:text-purple-400 transition-colors" />
              </div>
            </Card>
          ))}
          {events.length === 0 && (
            <Card className="p-12 glass text-center">
              <Calendar size={48} className="mx-auto mb-4 text-gray-600" />
              <h3 className="text-lg font-semibold text-gray-400">No events assigned</h3>
              <p className="text-gray-600 text-sm mt-1">Contact your administrator to get access to an event.</p>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventsPage;
